import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-overlay">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Enjoy Your Vacation With GHOOMO INDIA
            </h1>
            <p className="hero-subtitle">
              Discover the incredible beauty of India and beyond with our expertly crafted travel experiences
            </p>

            <div className="welcome-banner">
              <span className="welcome-text">Travel with us</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;